const e={Desktop:"desktop",Tablet:"tablet",Mobile:"mobile"};export{e as default};
